import React, { useState, useEffect, useContext } from "react";
import PosItemCard from "./PosItemCard";
import { Grid } from "@mui/material";
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc';
import _ from "lodash";
import { useSaveUserSettings } from "../../../shared/hooks/useFrappeDoctype";
import { AppContext } from "../../../AppContext";

// SortableItem component
const SortableItem = SortableElement(({ item, index, onClick, isDraggable }) => (
    <Grid item xs={6}>
        <PosItemCard item={item} index={index} onClick={onClick} isDragDropMode={isDraggable}/>
    </Grid>
));

// SortableList component
const SortableList = SortableContainer(({ items, onClick, isDraggable }) => (
    <Grid container spacing={2}>
        {items.map((item, index) => (
            <SortableItem key={`item-${item.item_code}`} index={index} item={item} onClick={onClick} isDraggable={isDraggable}/>
        ))}
    </Grid>
));

export default function PosItemList({
    onClick,
    menuItems,
    groupedItems,
    category,
    subCategory,
    onItemsLoaded,
    isDragDropMode,
}) {
    const { userMenuSettings } = useContext(AppContext);
    const [filteredItems, setFilteredItems] = useState([]);
    const saveUserSettings = useSaveUserSettings();

    useEffect(() => {
        let filteredItems = menuItems;

        if (category && category.id !== "All Item Groups") {
            const foundGroup = _.find(
                groupedItems,
                (groups, parentGroup) => parentGroup === category.id
            );
            let categories = [category.id];
            if (foundGroup && foundGroup.length > 0) {
                foundGroup.forEach((element) => {
                    categories.push(element.id);
                });
            }

            filteredItems = _.filter(menuItems, (item) =>
                _.includes(categories, item.item_group)
            );
        }

        if (subCategory) {
            filteredItems = _.filter(filteredItems, {
                item_group: subCategory.id,
            });
        }

        // Sort the filtered items based on the saved sorting index
        if (userMenuSettings && userMenuSettings.length > 0) {
            const itemIndexMap = userMenuSettings.reduce((acc, item) => {
                acc[item.item_code] = item.index;
                return acc;
            }, {});

            filteredItems = filteredItems.sort((a, b) => {
                const indexA = itemIndexMap[a.item_code] || 0;
                const indexB = itemIndexMap[b.item_code] || 0;
                return indexA - indexB;
            });
        }

        setFilteredItems(filteredItems);
    }, [category, subCategory, userMenuSettings]);

    useEffect(() => {
        if (menuItems && userMenuSettings) {
            let filteredItems = menuItems;

            if (userMenuSettings && userMenuSettings.item_sort_indices && userMenuSettings.item_sort_indices.length > 0) {
                const { item_sort_indices } = userMenuSettings;
                const itemIndexMap = item_sort_indices.reduce((acc, item) => {
                    acc[item.item_code] = item.index;
                    return acc;
                }, {});

                filteredItems = filteredItems.sort((a, b) => {
                    const indexA = itemIndexMap[a.item_code] || 0;
                    const indexB = itemIndexMap[b.item_code] || 0;
                    return indexA - indexB;
                });
            }

            setFilteredItems(filteredItems);

            if (onItemsLoaded) {
                onItemsLoaded(menuItems);
            }
        } else {
            setFilteredItems(menuItems);

            if (onItemsLoaded) {
                onItemsLoaded(menuItems);
            }
        }
    }, [menuItems, userMenuSettings]);

    const onSortEnd = ({ oldIndex, newIndex }) => {
        const updatedItems = arrayMove(filteredItems, oldIndex, newIndex);
        setFilteredItems(updatedItems);

        // Save the updated order to your state or backend
        if (onItemsLoaded) {
            onItemsLoaded(updatedItems);
        }

        handleSaveFilters(updatedItems);
    };

    const handleSaveFilters = (reorderedItems) => {
        if (userMenuSettings) {
            const _userSettings = { ...userMenuSettings };
            _userSettings.item_sort_indices = reorderedItems.map((item, index) => ({
                item_code: item.item_code,
                index,
            }));
            saveUserSettings.mutate(
                {
                    doctype: "menu_settings",
                    user_settings: _userSettings,
                },
                {
                    onSuccess: () => {
                        console.table("We have saved!");
                    },
                }
            );
        }
    };

    return (
        <div className={"CategoryView__Main"}>
            {isDragDropMode ? (
                <SortableList items={filteredItems} onSortEnd={onSortEnd} onClick={onClick} axis="xy" isDraggable={isDragDropMode} />
            ) : (
                <Grid
                    container
                    spacing={2}
                    style={{ width: '100%', boxSizing: 'border-box' }}
                >
                    {filteredItems &&
                        filteredItems.length > 0 &&
                        filteredItems.map((entry) => (
                            <Grid item xs={6} key={entry.item_code}>
                                <PosItemCard item={entry} onClick={onClick} isDragDropMode={isDragDropMode}/>
                            </Grid>
                        ))}
                </Grid>
            )}
        </div>
    );
}
